export default "__VITE_ASSET__O3MSHt0I__"